// Some pages use libraries that trap click events globally (see https://github.com/focus-trap/focus-trap),
// which prevents our componets to work correctly. This function disables global focus trapping for our ui components.
export function disableGlobalFocusTrapForPyneUI() {
  const listener = (e: Event) => {
    try {
      if (!(e.target instanceof Element)) return;
      const isPyneUi = e.target.className?.includes?.("pyne") || !!e.target.closest("#pyne-widget");
      if (isPyneUi && "stopImmediatePropagation" in e) {
        e.stopImmediatePropagation = () => {};
      }
    } catch (e) {
      console.log(e);
    }
  };
  document.addEventListener("click", listener, true);
}
